import { Box } from '@mantine/core'

function CircleText(props: CircleTextIconProps) {
  const { text } = props
  return (
    <Box
      style={{
        display: 'flex',
        borderRadius: 60,
        backgroundColor: '#464A4E',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: 22,
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
      }}
      w={40}
      h={40}
    >
      {text}
    </Box>
  )
}

interface CircleTextIconProps {
  text: string
}

export default CircleText
